
const despesaitemGridConfig = {
  idField: "idItemDespesa",
  columns: [
    { header: "Descrição", field: "DESCRICAO" },
    { header: "Vencimento", field: "VENCIMENTO" },
    { header: "Valor", field: "valor" }, 
    { header: "Ativo", field: "ATIVO",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default despesaitemGridConfig;